import { FC } from 'react'

import {
  alpha,
  InputLabel,
  lighten,
  Select,
  SelectProps,
  styled,
  SxProps,
  TextField,
  TextFieldProps
} from '@mui/material'
import { dialogInputStopPropagation } from '@/components/ConsoleDialog'

export type ConsoleTextFieldProps = Omit<TextFieldProps, 'error'> & {
  error?: string | boolean
  testId?: string
  errorSx?: SxProps
}

export const ListElement = styled('div')(({ theme }) => ({
  userSelect: 'none',
  marginTop: 1.5,
  padding: theme.spacing(1, 1.75),
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: alpha(lighten(theme.palette.primary.main, 0.5), 0.2)
  }
}))

export const ConsoleTextField: FC<ConsoleTextFieldProps> = ({
  error,
  testId,
  errorSx,
  ...props
}) => {
  return (
    <>
      <TextField
        {...dialogInputStopPropagation}
        fullWidth
        data-testid={testId}
        error={!!error}
        {...props}
        sx={{ height: 37, ...props.sx }}
      />
      {!!error && typeof error === 'string' && (
        <InputLabel sx={errorSx} error>
          {error}
        </InputLabel>
      )}
    </>
  )
}

// TODO: will be expanded to its own component
export const ConsoleSelect: FC<SelectProps> = (props) => (
  <Select {...dialogInputStopPropagation} {...props} />
)
